import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Form, Select as SelectAntd,  Input, Spin, Radio } from 'antd';


import Services, {
  IGetAllProgramaTv,
  IRequestCreateProgramaTV,
} from './services';

interface IProps {
  idPerfil: number;
}

let nomePessoa: string;


const SolicitacaoIntencao: React.FC<IProps> = ({
    idPerfil,

  }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loadingCreatePrograma, setLoadingCreatePrograma] = useState(false);

  const [checkUf, setCheckUf] = useState<any>();
  const [programas, setProgramas] = useState<IGetAllProgramaTv[]>([]);
  const [tipoSolicitacaoIntencaoTv, setTipoSolicitacaoIntencaoTv] = useState<number>(66);


  const loadProgramasTv = async () => {
    const services = new Services();
    const { error, response } = await services.GetAllProgramaTv();

    if (!error && response) {
      setProgramas(response);

    }
  };

  async function onSubmit(values: any) {
    setLoadingCreatePrograma(true);
    console.log(values);

    const createIntencao: IRequestCreateProgramaTV = {
      descricao: values.descricao,
     id_perfil: idPerfil,
     id_programa: values.programa_id,
     id_tipo_solicitacao: tipoSolicitacaoIntencaoTv,
     id_tipo_intencao_tv: values.id_tipo_intencao_missa,
    };

    const service = new Services();
    const { error, response } = await service.CreateIntencao(
      createIntencao,
    );

    //setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreatePrograma(false);
    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreatePrograma(false);
    }
  }


  const clearData = () => {
    formRef.setFieldsValue({
      programa_id: '',
      descricao: '',
    });
  };


  useEffect(() => {
    loadProgramasTv();

    window.document.title = 'CRM - Programa TV';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        justify="center"
        alignItems="center"
        sm={12}
        xs={12}
        style={{ marginTop: 20 }}
      >

        {/* FORMULARIO  */}
        <Grid
            container
            item
            xs={12}
            md={12}
            justify="center"
            alignItems="center"
          >
            <Spin
              size="large"
              spinning={loadingCreatePrograma}
              tip="Enviando dados..."
            >
              <Form
                form={formRef}
                scrollToFirstError={true}
                onFinish={onSubmit}
                requiredMark={false}
                style={{ width: '100%' }}
                layout="vertical"
                initialValues={{
                  programa_id: '',
                  descricao: '',
                }}
              >



                  <Grid container item lg={10} sm={10} xs={10} style={{ padding: 10 }}>






                  <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 10, paddingLeft: 10 }}
                    >
                      <Form.Item
                        label='Tipo programa'
                        name="programa_id"
                        rules={[
                          { required: true, message: 'Campo obrigatorio' },
                        ]}
                      >
                        <SelectAntd
                          style={{ width: '100%' }}

                        >
                          {programas.map((option, index) => (
                            <SelectAntd.Option key={option.id} value={option.id}>
                              {option.nome}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>
                      </Form.Item>
                    </Grid>

                    <Grid item lg={12} xs={12} style={{ paddingRight: 10, paddingLeft: 10 }}>
                      <Form.Item
                        label='Descrição'
                        name="descricao"
                        rules={[
                          {
                            //required: true,
                            //message: 'Selecione um horário',
                          },
                        ]}
                      >
                        <Input.TextArea />
                      </Form.Item>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      md={12}
                      xs={12}
                    >
                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          onClick={clearData}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item md={1} xs={12} style={{ paddingTop: 10 }}></Grid>

                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                        >
                          Solicitar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Grid>
              </Form>
            </Spin>
          </Grid>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencao;
